import React from "react";
import { toast } from "react-toastify";
import Layout from "../../components/Layout/Layout";
import Loading from "../../components/Loading";
import DispatchTable from "../../components/dispatchTable";
import { completeChallanWithImageApi, getAllDispatch } from "../../utils/api";
import useStore from "../../utils/store";

const DispatchByAdmin = () => {
  const [dash, setDash] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const startDate = useStore((state) => state.startDate);
  const endDate = useStore((state) => state.endDate);
  const [dispatchNote, setDispatchNote] = React.useState("");

  const getData = async () => {
    setLoading(true);
    const [success, data] = await getAllDispatch(startDate, endDate);
    if (success) {
      setDash(data);
    }
    setLoading(false);
  };

  const user = useStore((state) => state.user);

  React.useEffect(() => {
    getData();
  }, [startDate, endDate]);

  return (
    <Layout reload={getData}>
      {loading && <Loading />}
      <DispatchTable
        type="dispatch"
        data={dash}
        complete={async (ids, note, photoFile) => {
          setLoading(true);
          try {
            const formData = new FormData();
            formData.append("ids", JSON.stringify(ids));
            formData.append("type", "admin");
            formData.append("completedById", user?.admin?._id || user?._id || "");
            formData.append("dispatchNote", note || dispatchNote || "");
            if (photoFile) {
              formData.append("image", photoFile);
            }

            const [success, data] = await completeChallanWithImageApi(formData);
            if (success) {
              toast.success("✅ Dispatch Completed & Photo Attached!");
              getData();
              setDispatchNote("");
            } else {
              toast.error(data || "Failed to complete dispatch");
            }
          } catch (err) {
            console.error(err);
            toast.error("Error completing dispatch");
          } finally {
            setLoading(false);
          }
        }}
        dispatchNote={dispatchNote}
        setDispatchNote={setDispatchNote}
        refresh={getData}
      />
    </Layout>
  );
};

export default DispatchByAdmin;
